import './css/app.css'
import { client } from './client'
import Layout from '~/layouts/default'
import { createRoot } from 'react-dom/client'
import { createInertiaApp, type ResolvedComponent } from '@inertiajs/react'
import { TuyauProvider } from '@adonisjs/inertia/react'
import { resolvePageComponent } from '@adonisjs/inertia/helpers'
//import { createI18nInstance } from './i18n'
//import { I18nextProvider } from 'react-i18next'
import * as Sentry from '@sentry/react'

const appName = import.meta.env.VITE_APP_NAME || 'ConTroll'

createInertiaApp({
  title: (title) => (title ? `${title} - ${appName}` : appName),
  // The layout is passed as `[Layout]` rather than a `(page) => <Layout …/>`
  // callback. v3 treats any single-arg arrow assigned to `.layout` as a layout
  // *resolver* and calls it with page props first; a render function only
  // survives via a compatibility branch that re-invokes it with the page
  // element. The array form skips that guessing entirely. Rendering is
  // identical — Inertia nests the page as the layout's `children`.
  //
  // `resolve` must hand back the component itself, not the module: v3's
  // `ComponentResolver` accepts `{ default: Component }` synchronously or a
  // `Promise<Component>`, but not a promise *of* a module. The runtime still
  // unwraps `module.default`, so this is a typing requirement rather than a
  // behaviour change.
  resolve: async (name) => {
    const page = (await resolvePageComponent(
      `./pages/${name}.tsx`,
      import.meta.glob('./pages/**/*.tsx'),
      [Layout]
    )) as { default: ResolvedComponent }

    return page.default
  },
  setup({ el, App, props }) {
    //const locale = (props.initialPage.props.locale as string) || 'pl'
    //const i18nInstance = createI18nInstance(locale)

    if (
      import.meta.env.VITE_SENTRY_ENABLED === '1' ||
      import.meta.env.VITE_SENTRY_ENABLED === 'true'
    ) {
      Sentry.init({
        dsn: 'https://e1bcab0ada6e7c926e4023f35017234b@o4511688536948736.ingest.de.sentry.io/4511688574042192',
        environment: import.meta.env.MODE || 'development',
        tracesSampleRate: 0,
      })
    }
    createRoot(el).render(
      //<I18nextProvider i18n={i18nInstance}>
      <TuyauProvider client={client}>
        <App {...props} />
      </TuyauProvider>
      //</I18nextProvider>
    )
  },
  progress: {
    // Inertia reads this once at setup and wants a concrete colour, so it
    // cannot be a token that follows the theme. It is the light-theme
    // `--primary` value written out, rather than the stock gray-600 it used
    // to be — a 2px transient bar is legible on both grounds, and this at
    // least keeps it inside the design system. Update it if --primary moves.
    color: '#5A46D6',
  },
})
